import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, Box, useTheme, useMediaQuery } from "@mui/material";
import { SortableContext, horizontalListSortingStrategy } from '@dnd-kit/sortable';
import FormElement from "../../FormBuilder/FormElement";
import SortableElement from "../../FormBuilder/SortableElement";

const HorizotalContaier = ({
  items = [],
  dragHandle,
  setSelectedElementId,
  width,
  marginLeft,
  marginTop,
  formPreview = false,
  isPresentMode
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      className="horizontal-contaier"
      sx={{
        display: 'flex',
        flexWrap: isSmallScreen && !formPreview ? 'wrap' : 'nowrap',  // Conditionally apply flexWrap
        minHeight: '50px',
        width: isSmallScreen && !formPreview  ? '100%' : width,  // Full width on small screens
        marginLeft: isSmallScreen && !formPreview  ? 0 : marginLeft,
        marginTop: isSmallScreen && !formPreview  ? 1 : marginTop,
        gap: 1,  // Adds spacing between elements
      }}
    >
      <SortableContext items={items} strategy={horizontalListSortingStrategy}>
        {items.map((item, index) => (
          <Grid item key={item.id} xs={12} sm={6}>
            <SortableElement
              setSelectedElementId={setSelectedElementId}
              handle={true}
              key={item.id}
              id={item.id}
              index={index}
              element={item}
              dragHandle={dragHandle}
              isInsideHorizontalContainer={true}
            >
              <FormElement element={item} />
            </SortableElement>
          </Grid>
        ))}
      </SortableContext>
    </Box>
  );
};
HorizotalContaier.propTypes = {
  initialItems: PropTypes.arrayOf(PropTypes.element),
  width: PropTypes.string,
};

export default HorizotalContaier;
